import { INICIO } from './url.constant';

export const GENERIC_ERROR = {
  titleRetry: "Lo sentimos, en este momento no podemos atender tu solicitud",
  infoRetry:
    "El servicio no se encuentra disponible. Por favor, vuelve a intentarlo.",
  // subtitleRetry: 'Ante dudas llámanos al <b>600 6600 900</b>, escríbenos a WhatsApp <b>+569 3639 1222</b> o dirígete a nuestras sucursales.',
  subtitleRetry:
    'Para más información llámanos al <a class="referencia" href="tel:6006600900">600 6600 900</a>, escríbenos al WhatsApp <a class="referencia" href="https://wa.me/56936391222" target="_blank">+569 3639 1222</a>, dirígete a nuestras sucursales, o agenda una <a class="referencia" href="/video-atencion">Video Atención</a>.',
  srcImage: "/assets/contactotdp/icons/info_fill.svg",
  buttonTextPrimary: "Reintentar",
  buttonTextSecondary: "Ir a Inicio",
  buttonUrlSecondary: INICIO,
  enableButtonRetry: true,
};
export const ERROR_CLIENTE_AUN_SIN_PAGO = {
  titleRetry: "La información de tu pago aún no está disponible",
  infoRetry:
    "¿Por qué no tienes esta información? <ul><li>Porque <b>estás recién pensionado por la AFP.</b> Pronto podrás acceder al detalle de tu último y próximo pago.</li><li>Porque <b>tu pensión es pagada por una Compañía de Seguros,</b> y debes consultar con ellos el detalle de tus pagos.</li><li>Tus <b>pagos podrían estar suspendidos,</b> porque tienes cheques sin cobrar u otras razones. Comunícate con nosotros para saber cuál es tu caso de suspensión.</li><li>Porque <b>se acabaron tus ahorros previsionales.</b> Si este es tu caso, te recomendamos acceder a <a class='referencia' href='https://mi.chileatiende.gob.cl/tramites/sibs' target='_blank'>ChileAtiende</a> y revisar si tienes derecho a un beneficio estatal.</li></ul>",
  subtitleRetry:
    'Llámanos al <a class="referencia" href="tel:6006600900">600 6600 900</a>, escríbenos al WhatsApp <a class="referencia" href="https://wa.me/56936391222" target="_blank">+569 3639 1222</a> o agenda una <a class="referencia" href="/video-atencion">Video Atención</a>.',
  srcImage: "/assets/contactotdp/icons/info_fill.svg",
  buttonTextSecondary: "Ir a Inicio",
  buttonUrlSecondary: INICIO,
  enableButtonRetry: false,
};
